export default {
  PERMANENT: 'PERMIT_TO_LIVE_PERMANENTLY',
  PASSPORT: 'PASSPORT',
  ID_CARD: 'ID_CARD',
};
